import {create} from 'zustand';

const useOMEContentStore = create((set) => ({
    content: null,
    setContent: (content) => set(() => ({ content })), 
}));

export default useOMEContentStore;
